import { render } from "./DataExportIcon.vue?vue&type=template&id=5211064c&ts=true"
import script from "./DataExportIcon.vue?vue&type=script&lang=ts"
export * from "./DataExportIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__